import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=5069800c&scoped=true"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=5069800c&prod&lang=scss&scoped=true"
import style1 from "./UserDashboard.vue?vue&type=style&index=1&id=5069800c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069800c",
  null
  
)

export default component.exports